export default function Preloader() {
    return <div />;
}
